import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';

import { AUTHENTICATED_EXTERNAL_LINK_CONFIG } from '../authenticated-external-link-options';
import { handleAuthenticatedExternalLinkClick } from '../handlers/authenticated-external-link-click-handler';
import { AuthenticatedExternalLinkService } from '../services/authenticated-external-link.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a[href]',
  standalone: true
})
export class AuthenticatedExternalLinkDirective implements OnInit, OnDestroy {
  private readonly element = inject(ElementRef<HTMLAnchorElement>);
  private readonly config = inject(AUTHENTICATED_EXTERNAL_LINK_CONFIG);
  private readonly authenticatedExternalLink = inject(
    AuthenticatedExternalLinkService
  );

  private readonly onClickCapture = (event: Event): void => {
    handleAuthenticatedExternalLinkClick({
      event: event as MouseEvent,
      link: this.element.nativeElement,
      routes: this.config.routes,
      openRoute: (route, sourceHref, trackingId) =>
        this.authenticatedExternalLink.openRoute(route, sourceHref, trackingId)
    });
  };

  ngOnInit(): void {
    this.element.nativeElement.addEventListener(
      'click',
      this.onClickCapture,
      true
    );
  }

  ngOnDestroy(): void {
    this.element.nativeElement.removeEventListener(
      'click',
      this.onClickCapture,
      true
    );
  }
}
